import React, { Suspense } from "react";
import { useLocation, Navigate } from "react-router-dom";

import { useAuth } from "@/contexts/auth/useAuth";
import { cacheCurrentUrl } from "@/utils/redirect";

import ColumnLoading from "../components/column-loading";

type PageProps = {
  layout?: any;
  children: React.ReactNode;
};

interface WrappedRouteProps {
  component: (...args: any[]) => any;
  page: React.ComponentType<PageProps>;
  publicRoute?: boolean;
}

const WrappedRoute: React.FC<WrappedRouteProps> = ({
  component,
  page: Page,
  publicRoute = false,
}) => {
  const { currentAccount } = useAuth();
  const location = useLocation();
  const renderWithLayout = (children: React.JSX.Element) => <>{children}</>;

  const renderLoading = () => renderWithLayout(<ColumnLoading />);

  const loginRedirect = () => {
    cacheCurrentUrl(location);
    return <Navigate to="/" replace />;
  };

  const authorized = !!currentAccount || publicRoute;

  if (!authorized) {
    if (!currentAccount) {
      return loginRedirect();
    }
  }

  const Component = component;

  const children = (
    <Suspense fallback={renderLoading()}>
      {Page ? (
        <Page>
          <Component />
        </Page>
      ) : (
        <Component />
      )}
    </Suspense>
  );

  return renderWithLayout(children);
};

export { WrappedRoute };
